// Project: GSSC Pilot Front-end
// Filename: asset_filter.js
// Copyright European Space Agency, 2020
// This file is part of the source code package for contract PO PO 5001024866
// No part of the package, including this file, may be copied, modified,
// propagated, or distributed without prior approval by ESA.
const SHOW_LIMIT = 5;

export default class AssetFilter {
  constructor(label, children = [], count = 0) {
    this.label = label;
    this.parentLabel = '';
    this.setChildren(children);
    this.setCount(count);
    // expander
    this.isExpander = false;
    // this filter's expander
    this.expander = null;
  }

  get tagLabel() {
    return `${this.parentLabel} > ${this.label}`;
  }

  get display() {
    let label = `${this.label}`;
    if (this.count) {
      label += ` (${this.count.toLocaleString('en-US')})`;
    }
    return label;
  }

  get theField() {
    return this.field;
  }

  get theVal() {
    return this.val;
  }

  // Get all child filters by label (including expander's filters)
  get fullChildrenByLabel() {
    return this.fullChildren.reduce(
      (bylabel, child, idx) => ({ ...bylabel, [child.label]: { idx, child } }),
      {}
    );
  }

  setChildren(children) {
    this.fullChildren = children;
    this.renderExpander();
  }

  renderExpander() {
    const newChildren = [...this.fullChildren];

    // Show first 5 children filters only
    // If there are more than 5 then add a "more" button to popup a modal
    this.children = newChildren.splice(0, SHOW_LIMIT);
    if (newChildren.length > 0) {
      // add "more" button and set modalChildren
      const expander = new AssetFilter(this.label);
      expander.setExpander(this.fullChildren);
      this.expander = expander;
      this.children.push(expander);
    }
  }

  addChildren(children, sortByCount) {
    this.fullChildren = this.fullChildren.concat(children);
    if (sortByCount) {
      this.fullChildren.sort((a, b) => {
        if (a.count > b.count) {
          return -1;
        }
        return 1;
      });
    } else {
      // only in sampling_rate case
      const sortingArray = [
        '0 - < 1 s',
        '1 s - < 60 s',
        '1 min - < 5 min',
        '5 min - < 15 min',
        '> 15 min'
      ];
      this.fullChildren.sort((a, b) => {
        console.log('sorting', a, b);
        return sortingArray.indexOf(a.label) - sortingArray.indexOf(b.label);
      });
    }
    this.renderExpander();
  }

  keepOnly(idxs) {
    const newChildren = idxs.map(idx => this.fullChildren[idx]);
    this.setChildren(newChildren);
  }

  setCount(count) {
    this.count = count;
  }

  // Set this filter to be a button to popup a modal
  // and set filters to show on the modal
  setExpander(filters) {
    this.isExpander = true;
    this.modalFilters = filters;
  }

  setParentLabel(label) {
    this.parentLabel = label;
  }

  // The field name for the API
  setField(field) {
    this.field = field;
  }

  // The value used to pass to API for filtering
  setVal(val) {
    this.val = val;
  }
}
